require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./es-basic-styles-sandbox-form-sandbox.json") })
        }
      }, "path---es-basic-styles-sandbox-form-sandbox");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---es-basic-styles-sandbox-form-sandbox!./.cache/json/es-basic-styles-sandbox-form-sandbox.json
// module id = 2489
// module chunks = 231608221292675